<template>
  <el-dialog :visible="show" append-to-body width="660px" title="场景编辑" @close="closeDialog">
    <el-form label-width="135px" :model="vForm" ref="vForm">
      <el-form-item label="场景名称" prop="name" :rules="{ required: true, message: '场景名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>

      <template v-if="config.WEB == 4">
        <el-form-item label="背景音乐">
          <upload-audio v-model="background_sound_media_info" class="v-mt-5" />
          <div class="v-form-tips">场景背景音乐会覆盖全局背景音乐</div>
        </el-form-item>

        <el-form-item label="语音讲解">
          <upload-audio v-model="explain_sound_media_info" class="v-mt-5"></upload-audio>
          <div class="v-form-tips">场景语音讲解会覆盖全局语音讲解</div>
        </el-form-item>
      </template>

      <div v-if="config.WEB == 3" v-loading="tzLoading">
        <div class="section-title">简介</div>
        <el-form-item label="场景名称" prop="resume_name" :rules="{ required: true, message: '场所名称必填' }">
          <el-input v-model="vForm.resume_name"></el-input>
        </el-form-item>
        <el-form-item label="具体地址" prop="address" :rules="{ required: true, message: '具体地址必填' }">
          <el-input v-model="vForm.address"></el-input>
        </el-form-item>
        <el-form-item label="崇拜类型" prop="type_id" :rules="{ required: true, message: '崇拜类型必填' }">
          <el-select v-model="vForm.type_id" v-loading="tzTypeLoading" style="width: 100%" @change="onChangeType">
            <el-option v-for="item in tzTypeList" :label="item.name" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tzTypeValue == ''" label="神邸神像" prop="content" :rules="{ required: true, message: '神邸神像必填' }">
          <el-input v-model="vForm.content"></el-input>
        </el-form-item>
        <el-form-item label="占地面积">
          <el-input v-model="vForm.cover_area" type="number">
            <template slot="append">㎡</template>
          </el-input>
        </el-form-item>
        <el-form-item label="硬化场地面积">
          <el-input v-model="vForm.site_area" type="number">
            <template slot="append">㎡</template>
          </el-input>
        </el-form-item>
        <el-form-item label="建筑面积">
          <el-input v-model="vForm.build_area" type="number">
            <template slot="append">㎡</template>
          </el-input>
        </el-form-item>
        <el-form-item label="主体建筑建成时间" prop="built_time" :rules="{ required: true, message: '主体建筑建成时间必填' }">
          <el-input v-model="vForm.built_time" style="width: 100%" />
        </el-form-item>
        <el-form-item label="拍摄时间" prop="record_time" :rules="{ required: true, message: '拍摄时间必填' }">
          <el-date-picker v-model="vForm.record_time" style="width: 100%" type="date" placeholder="选择时间" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="自定义内容">
          <el-input type="textarea" style="width: 100%" :autosize="{ minRows: 4 }" resize="none" placeholder="请输入内容" v-model="vForm.desc" />
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>

    <v-media-vr v-if="isShowMediaVr" :show.sync="isShowMediaVr" :ids="selectedVrIds" @select="handleSelectVr" />
  </el-dialog>
</template>

<script>
export default {
  props: ['show', 'row'],

  data() {
    let background_sound_media_info = this.row.background_sound_media_info ? this.row.background_sound_media_info : {};
    let explain_sound_media_info = this.row.explain_sound_media_info ? this.row.explain_sound_media_info : {};
    return {
      doSubmitLoading: false,
      isShowMediaVr: false,
      isRecover: false, //是否重新上传vr
      works_id: this.$route.query.id,
      vForm: {
        id: this.row.id,
        sort: this.row.sort,
        name: this.row.name,
        thumb: this.row.thumb,
        material_id: this.row.material_id,
        scene_name: '',
        resume_name: '',
        address: '',
        type_id: '',
        cover_area: '',
        site_area: '',
        build_area: '',
        built_time: '',
        record_time: '',
        content: '',
        desc: '',
        info: {
          background_sound_media_id: background_sound_media_info.id ? background_sound_media_info.id : '',
          explain_sound_media_id: explain_sound_media_info.id ? explain_sound_media_info.id : '',
        },
      },
      background_sound_media_info: {
        //背景音乐
        id: background_sound_media_info.id,
        key: background_sound_media_info.key,
        preview: background_sound_media_info.key_preview,
        name: background_sound_media_info.name,
      },
      explain_sound_media_info: {
        //解说
        id: explain_sound_media_info.id,
        key: explain_sound_media_info.key,
        preview: explain_sound_media_info.key_preview,
        name: explain_sound_media_info.name,
      },
      editorConfig: {
        //ueditor编辑器配置
        UEDITOR_HOME_URL: '/UEditor/',
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        initialFrameWidth: 480,
        serverUrl: this.config.API_BASE + '/api/upload/getEditorUpload',
      },
      selectedVrIds: [],
      selectVrLoading: false,
      tzTypeList: [],
      tzTypeLoading: false,
      tzLoading: false,
      tzTypeValue: '',
    };
  },

  created() {
    if (this.config.WEB == 3) {
      this.getTzData();
    }
  },

  methods: {
    //获取
    async getTzData() {
      this.tzLoading = true;
      try {
        let res = await this.api.vr.resume({ works_material_id: this.row.id });
        if (res.data) {
          res.data.resume_name = res.data.name;
          res.data.type_id = Number(res.data.type_id);
          delete res.data.name;
          delete res.data.id;
          for (let key in res.data) {
            this.vForm[key] = res.data[key];
          }
        }
        this.getTzType();
      } catch (e) {
        console.error(e);
      }
      this.tzLoading = false;
    },

    //获取折线类型数据
    async getTzType() {
      this.tzTypeLoading = true;
      try {
        let res = await this.api.setting.getPointsType({ channel: 'tzType' });
        this.tzTypeList = res.data;
        this.onChangeType();
      } catch (e) {
        console.error(e);
      }
      this.tzTypeLoading = false;
    },

    onChangeType() {
      if (!this.vForm.type_id) {
        return;
      }
      this.tzTypeValue = this.tzTypeList.filter((item) => item.id == this.vForm.type_id)[0].value;
    },

    closeDialog() {
      this.$emit('update:show', false);
    },

    //获取所有场景列表
    async getSceneListAll() {
      let res = await this.api.works.getSceneList({
        works_id: this.works_id,
      });
      return res.data;
    },

    //选择vr
    async showSelectVr() {
      this.selectVrLoading = true;
      try {
        this.selectedVrIds = (await this.getSceneListAll()).map((item) => item.material_id);
        this.isShowMediaVr = true;
      } catch (e) {
        console.error(e);
      }
      this.selectVrLoading = false;
    },

    //覆盖场景
    async handleSelectVr(materials) {
      this.vForm.material_id = materials[0].id;
      this.vForm.thumb = materials[0].key_preview;
      this.isRecover = true;
    },

    //提交
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.works.editScene(this.vForm);
        this.$message.success('修改成功');
        this.$emit('success', this.vForm);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped>
.thumb-preview {
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-size: cover;
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
}

.thumb-preview .mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.5;
  cursor: pointer;
}

.section-title {
  font-size: 16px;
  text-align: center;
  padding: 10px 0;
  margin-bottom: 10px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
</style>
